import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { ProgressBarProps } from './types'
import './ProgressBar.css'

/** Barra de progreso de flujo (DESIGN.md §4): segmentos discretos, "Paso X de N" y Atrás siempre disponible. */
export function ProgressBar({ step, total, onBack, backLabel, saved, className }: ProgressBarProps) {
  const { t } = useTranslation()
  const current = Math.min(Math.max(step, 1), total)
  const counter = t('v2.ds.progress.paso', { step: current, total })
  return (
    <div className={cx('hp-progress', className)}>
      <div className="hp-progress__row">
        <button type="button" onClick={onBack} className="hp-progress__back">
          <Icon name="arrow-left" size={22} />
          <span>{backLabel ?? t('v2.comun.atras')}</span>
        </button>
        <span className="hp-progress__counter tnum" aria-live="polite">
          {saved ? `${counter} · ${t('v2.ds.progress.guardado')}` : counter}
        </span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-valuetext={counter}
        aria-label={counter}
        className="hp-progress__segments"
      >
        {Array.from({ length: total }, (_, i) => (
          <span key={i} className={cx('hp-progress__segment', i < current && 'hp-progress__segment--done')} />
        ))}
      </div>
    </div>
  )
}
